import { render, staticRenderFns } from "./EditNickName.vue?vue&type=template&id=72d3c205&scoped=true"
import script from "./EditNickName.vue?vue&type=script&lang=js"
export * from "./EditNickName.vue?vue&type=script&lang=js"
import style0 from "./EditNickName.vue?vue&type=style&index=0&id=72d3c205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3c205",
  null
  
)

export default component.exports